<template>
<div>
	<Form :label-width="110" @submit.native.prevent>
		<Row :gutter="10">
			<Col span="8">
				<FormItem label="参保公司">
					<Input v-model="params.companyName" clearable @on-enter="search" placeholder="参保公司名称"></Input>
				</FormItem>
			</Col>
			<Col span="16" class="right">
				<Button type="info" @click="search">搜索</Button>
				<Button type="primary" @click="excel">导出</Button>
			</Col>
		</Row>
	</Form>
	<i-table :columns="columns" url="/trainee/queryCompany" :params="params" ref="table" >
		<template slot-scope="{ row, index }" slot="organizationUrl">
			<a :href="row.organizationUrl" target="_blank" v-if="row.organizationUrl">查看</a>
		</template>
		<template slot-scope="{ row, index }" slot="address">
			{{row.provinceName}}{{row.cityName}}{{row.areaName}}{{row.address}}
		</template>
		<template slot-scope="{ row, index }" slot="action">
			<a @click="openEdit(row)">编辑</a>
		</template>
	</i-table>
	<Modal v-model="editShow" title="编辑公司信息" :mask-closable="false" >
		<Form :label-width="110" v-if="editShow" :model="editForm" :rules="editFormRules" ref="editForm">
			<Form-item label="公司名称" prop="companyName">
				<Input v-model="editForm.companyName" clearable placeholder="公司名称"></Input>
			</Form-item>
			<Form-item label="企业类型" prop="companyType">
				<Select v-model="editForm.companyType" placeholder="请选择企业类型">
					<Option v-for="item in companyTypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
				</Select>
			</Form-item>
			<Form-item label="统一社会信用代码" prop="organizationCode">
				<Input v-model="editForm.organizationCode" clearable :maxlength="18" @on-change="resetUpperCaseValue"></Input>
			</Form-item>
			<Form-item label="通讯地址" prop="areaCode">
				<Area v-model="editForm.areaCode" placeholder="请选择省市区" @get-city-str="areaChange"></Area>
			</Form-item>
			<Form-item prop="address">
				<Input v-model="editForm.address" clearable placeholder="详细地址"></Input>
			</Form-item>
			<Form-item label="邮政编码" prop="postCode">
				<Input v-model="editForm.postCode" clearable placeholder="邮政编码"></Input>
			</Form-item>
			<Form-item label="营业执照" prop="organizationUrl" >
				<UploadFileImg @on-success="editBindUploadSuccess" :accept="['image']" validate-format type="select" btn-text="上传"/> 
				<a @click="openOriginFile(editForm.organizationUrl)" v-show="editForm.organizationUrl" class="ml20">查看</a>
			</Form-item>
		</Form>
		<div slot="footer" style="text-align: center">
			<Button @click="cancelEdit" type="default">取消</Button>
			<Button @click="confirmEdit" type="primary" :loading="saving" :disabled="saving">确定</Button>
		</div>
	</Modal>
</div>
</template>

<script>
import ITable from '@/components/common/ITable'
import UploadFileImg from '@/components/common/UploadFileImg'
import Area from '@/pages/haierProduct/components/common/Area'

export default {
	components:{ITable,UploadFileImg,Area},
	data () {
		return {
			params:{},
			columns:[
				{title: '公司名称',key: 'companyName',minWidth:200,fixed: 'left'},
				{title: '企业类型',key: 'companyTypeName',minWidth:200},
				{title: '统一社会信用代码',key: 'organizationCode',minWidth:200},
				{title: '通讯地址',slot: 'address',minWidth:200},
				{title: '邮政编码',key: 'postCode',minWidth:200},
				{title: '联系人',key: 'name',width:100},
				{title: '手机号',key: 'phone',width:130},
				{title: '邮箱',key: 'email',width:180},
				{title: '营业执照',slot: 'organizationUrl',width:100},
				{title: '操作',slot: 'action',width:80,fixed:'right'},
			],
			total:'',
			editForm:{},
			companyTypeList:[
				{value:'STATE_OWNED',label:'国有企业'},
				{value:'COLLECTIVE',label:'集体企业'},
				{value:'SHARE_COOPERATIVE',label:'股份合作企业'},
				{value:'LIMITED_LIABILITY',label:'有限责任公司'},
				{value:'JOINT_STOCK',label:'股份有限公司'},
				{value:'PRIVATE',label:'私营企业'},
				{value:'JOINT_OPERATION',label:'联营企业'},
				{value:'JOINT_VENTURE_HK_MO_TW',label:'合资经营企业（港或澳、台资）'},
				{value:'COOPERATIVE_HK_MO_TW',label:'合作经营企业（港或澳、台资）'},
				{value:'SOLE_HK_MO_TW',label:'港、澳、台商独资经营企业'},
				{value:'SINO_FOREIGN_JOINT_VENTURE',label:'中外合资经营企业'},
				{value:'SINO_FOREIGN_COOPERATIVE',label:'中外合作经营企业'},
				{value:'FOREIGN_ENTERPRISE',label:'外资企业'},
				{value:'INSTITUTION',label:'事业单位'},
				{value:'ORGANIZATION',label:'机关团体'},
				{value:'AGENCY',label:'代理机构'},
				{value:'OTHER',label:'其他企业'}
			], //企业类型
			editFormRules:{
				companyName:[{required:true,message:'请输入公司名称',trigger:'blur'}],
				companyType:[{required:true,message:'请选择企业类型',trigger:'change'}],
				postCode:[{required:true,message:'请输入邮政编码',trigger:'blur'}],
				organizationCode:[{required:true,message:'请输统一社会信用代码',trigger:'blur'},{message:'格式错误',trigger:'blur',pattern:this.rules.organizationCode}],
				areaCode:{required:true,message:'请选择地区',trigger:'change'},
				address:{required:true,message:'请输入详细地址',trigger:'blur'},
				organizationUrl:{required:true,message:'请上传营业执照',trigger:'change'},
			},
			editShow:false,
			saving:false
		}
	},
	created () {
	},
	methods: {
		search () {
			this.$refs.table.getList();
		},
		excel () {
			this.exportToExcel("/trainee/exportCompany",this.params);
		},
		// 选择省市区
		areaChange(val){
			console.log(val)
			this.editForm.provinceCode=val[0].value
			this.editForm.provinceName=val[0].label
			this.editForm.cityCode=val[1].value
			this.editForm.cityName=val[1].label
			this.editForm.areaName=val[2].label
		},
		// 导入参保公司
		toImport(){
			this.$router.push('/haier/trainee/company-import')
		},
		// 编辑绑定人员上传附件成功
		editBindUploadSuccess(val) {
			this.$set(this.editForm,'organizationUrl',val.url)
		},
		// 打开编辑人员
		openEdit(row){
			this.editShow=true;
			this.$nextTick(()=>{
				this.editForm= this.jsonCopy(row)
			})
		},
		// 确定编辑人员
		confirmEdit(){
			if(this.saving) return;
			this.$refs.editForm.validate((valid) => {
				if (valid) {
					this.saving = true;
					this.$axios.post('/trainee/editCompany',this.editForm).then(res=>{
						this.toast('编辑成功')
						this.search()
						this.cancelEdit()
					}).finally(() => {
						this.saving = false;
					});
				}
			})
		},
		// 关闭
		cancelEdit(){
			this.editShow = false;
			this.$refs.editForm.resetFields();
		},
		// 小写转大写
		resetUpperCaseValue(event){
			if(event.target.value){
				this.editForm.organizationCode=event.target.value.toUpperCase();
			}
		}

	}
}
</script>


// WEBPACK FOOTER //
// src/pages/haierProduct/components/traineeEmployer/list/Company.vue